import React from 'react';
import { getDateDay, getPrimaryButtonProps } from './helpers';
import Icon from 'shared/components/Icon';
import LandingPageCTAButton from 'shared/components/LandingPageCTA/LandingPageCTAButton';

import CalendarIcon from 'assets/images/calendar-green.svg';
import ClockIcon from 'assets/images/clock-green.svg';
import { useTranslation } from 'react-i18next';

const PrimaryUpcomingWebinar = ({ upcomingWebinar }) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className="card-title">{t('Upcoming Webinars')}</h3>

      <div className="upcoming-webinar employee-dashboard">
        <p className="webinar-title">{upcomingWebinar.name}</p>

        <div className="schedule-wrapper">
          <Icon icon={CalendarIcon} />
          <p>{getDateDay(upcomingWebinar)}</p>
        </div>

        <div className="schedule-wrapper">
          <Icon icon={ClockIcon} />
          <p>{upcomingWebinar.formattedDate.split('|')[1]}</p>
        </div>

        <LandingPageCTAButton {...getPrimaryButtonProps(upcomingWebinar)} />
      </div>
    </>
  );
};

export default PrimaryUpcomingWebinar;
